import React from 'react'
import { useMain } from '../../Hook/Main';
import Layout from '../../Layout'
import HeaderMain from '../../Components/HeaderMain'
function Index() {
    const { data } = useMain();
    const Item = ({ item }) => {
        return (
            <div className='notif-item'>
                <p>{item.message}</p>
                <div>{item.time}</div>
            </div>
        )
    }
    return (
        <Layout>
            <HeaderMain lable="اعلانات" />
            <div className="notifications">
                {data.Notificatios && data.Notificatios.map((item, i) => <Item item={item} key={i} />)}
            </div>
        </Layout>
    )
}
export default Index